import { array, boolean, mixed, number, object, string } from "yup";
import { Roles } from "@utils/settings";

export type DietitianClinicListResource = {
  id: number;
  active: boolean;
  firstName: string;
  lastName: string;
  email: string;
  title: string | null;
  avatar?: string | null; // deprecated, keep for now if backend sends it
  avatarNew?: string | null;
  clientsCount: number;
  facility?: {
    id: number;
    name: string;
  } | null;
  phone: {
    prefix?: string | null;
    number?: string | null;
  };
  roles: Roles[];
  permissions?: {
    canViewAllPatients?: boolean;
  };
  uuid: string | null;
};

export const dietitianClinicListResourceSchema = object({
  id: number().required(),
  active: boolean().required(),
  firstName: string().required(),
  lastName: string().required(),
  email: string().required(),
  title: string().nullable().default(null),
  avatar: string().nullable().default(null),
  avatarNew: string().nullable().default(null),
  clientsCount: number().min(0).required(),
  facility: object({
    id: number().min(1).required(),
    name: string().required(),
  })
    .nullable()
    .default(null),
  phone: object({
    prefix: string().nullable().default(null),
    number: string().nullable().default(null),
  }).required(),
  roles: array()
    .of(
      mixed<Roles>()
        .oneOf(Object.values(Roles) as Roles[])
        .required(),
    )
    .required(),
  permissions: object({ canViewAllPatients: boolean() }).optional(),
  uuid: string().nullable().default(null),
});
